// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5ea6259f","732":"54b2c6c6","977":"250f9e82"}[chunkId] + ".chunk.js";
};